import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';

export const FiStateResolveApplicationLanguages = [
    ContentLanguagesService,
    FiStateResolveApplicationLanguagesResolveFunc,
];

export function FiStateResolveApplicationLanguagesResolveFunc(contentLanguagesService: ContentLanguagesService) {
    return contentLanguagesService.GetApplicationLanguages();
}
